import { Input } from "Components/Form/Input";
import { InputMode } from "Components/Form/Input/inputTypes";
import { updatePriceCalculationFormState } from "Store/priceCalculation/priceCalculationSlice";
import { TextLanguage } from "Store/texts/interfaces";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { useDispatch } from "react-redux";
import { ADVICE_PRICE_STEP } from "../../adviceSteps";
import { AdvicePriceFormValues } from "../AdviceCards/interfaces";
interface Props {
  formProps: FormikProps<AdvicePriceFormValues>;
  formText: any;
  lang: TextLanguage;
}

export const AdviceComment = ({
  formProps,
  formText,
  lang,
}: Props): React.ReactElement => {
  const advice = formText.advice;
  const dispatch = useDispatch();

  const handleAdviceCommentChange = (value: string): void => {
    dispatch(
      updatePriceCalculationFormState({
        stepId: ADVICE_PRICE_STEP.id,
        formState: {
          ...formProps.values,
          adviceComment: value,
        },
      }),
    );
  };

  return (
    <div className="data-hj-suppress">
      <Input
        id="adviceComment"
        name="adviceComment"
        label={advice.adviceComment.label[lang]}
        hint={advice.adviceComment.hint[lang]}
        as={"textarea"}
        rows={3}
        fluid
        error={getError("adviceComment", formProps)}
        onChange={(e) => {
          handleAdviceCommentChange(e.target.value);
        }}
        inputMode={InputMode.TEXT}
        debounced
      />
    </div>
  );
};
